import React from "react";
import { Container, Row, Col, Card, Button, Image} from "react-bootstrap";
import { Helmet } from "react-helmet";
import '../styles/Home.css';


const Contact = () => {
    const containerStyle = {
      backgroundImage: 'url("/images/img_2.png")',
      backgroundSize: 'cover',
      width: '100vw',
      height: '147vh'
    }
    const textStyle = {
      color: 'white'
    }
      const phoneNumber = '+77010689960';
      const phoneNumber1 = '+77019589095';
      const emailAddress = 'info@kromsan.kz'; 
    
      const handlePhoneClick = () => {
        window.location.href = `tel:${phoneNumber}`;
      };

      const handlePhoneClick1 = () => {
        window.location.href = `tel:${phoneNumber1}`;
      };
    
      const handleEmailClick = () => {
        window.location.href = `mailto:${emailAddress}`;
      };
    
      
    return(
        <div style={containerStyle}>
          <Helmet>
          <title>Kromsan контакты</title>
          <meta name="description" content="МЕБЕЛЬ ИЗ ВЫСОКОКАЧЕСТВЕННОЙ НЕРЖАВЕЮЩЕЙ СТАЛИ AISI 304 И AISI 430, оборудование для кухни, комплексное оснащение гостиниц и ресторанов, HORECA, Kromsan" />
          </Helmet>
          <Container>
          <Image className="pt-5" width={200} height={150} src="/images/logo.png"/>
      <Row className="pt-5">
        <Col md={6}>
                <h1 style={textStyle}>Наши контакты</h1>
                
                <p style={textStyle}>
                  <strong>Директор отдела продаж:</strong> {' '}
                  <Button href={`tel:${phoneNumber1}`} variant="primary" onClick={handlePhoneClick1}>
                  <i className="bi bi-phone">{phoneNumber1}</i> 
                </Button>
                </p>
                <p style={textStyle}>
                <strong>Телефон:</strong> {' '}
                  
                  <Button href={`tel:${phoneNumber}`} variant="primary" onClick={handlePhoneClick}>
                  <i className="bi bi-phone">{phoneNumber}</i> 
                </Button>
                </p>
                <p style={textStyle}>
                  <strong>Email:</strong> {' '}
                  <Button href={`mailto:${emailAddress}`} variant="warning" onClick={handleEmailClick}>
                  <i className="bi bi-envelope"></i> {emailAddress}
                </Button>
                </p>
              
        </Col>
        <Col md={6}>
          <h1 style={textStyle}>Адресс компании</h1>
          <p style={textStyle}>РЕСПУБЛИКА КАЗАХСТАН
        АЛМАТИНСКАЯ ОБЛ.,
        КАРАСАЙСКИЙ РАЙОН,
        СЕЛО ЖАРМУХАМБЕТ, 400</p>
        </Col>
      </Row>
    </Container>
    
      <Container className="mb-3">
      <div className="center-cards">
          <Card style={{ width: '100%', float: 'right', margin: '30px'}}>
      <Card.Text>
        <iframe
          className="pt-3"
          src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac38a9b5664c6345a6843ae8c9b3f32d63579013ea520f246cd03e1a0a0f291c0&amp;source=constructor"
          width="100%"
          height="438"
          frameBorder="0"
          title="map"
        />
      </Card.Text>
      <Card.Body>
        <Card.Title>АДРЕС:</Card.Title>
        <Card.Text>
        РЕСПУБЛИКА КАЗАХСТАН
        АЛМАТИНСКАЯ ОБЛ.,
        КАРАСАЙСКИЙ РАЙОН,
        СЕЛО ЖАРМУХАМБЕТ, 400.
        Тел: +7 700 391 33 11
        </Card.Text>
        <Button href="https://yandex.ru/maps/?rtext=~43.369590, 76.796237" variant="primary">Проложить маршрут</Button>
      </Card.Body>
    </Card>
    </div>
      </Container> 
      

    </div>
    )
};


export default Contact;